var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline"},[_vm._m(0),_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"combination"},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"line"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"combination"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"circle"})])
}]

export { render, staticRenderFns }